import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useNavigationUtils, useActions } from '@mssgme/hooks';
import { NavBackButton, SidebarHeader, ScrollableBox, Feature } from '@mssgme/ui';

import { PageLayout } from '../../../UI';
import CardStatistics from './CardStatistics';

export default function Analytics() {
    const { t } = useTranslation('cards');
    const statistics = useSelector((state) => state.cardStatistics);
    const { generateUrl } = useNavigationUtils();
    const actions = useActions();

    const getCardStatistics = useCallback(
        (from = 'now-7d', to = 'now') => actions.api.card.statistics({ query: { from, to } }),
        []
    );

    const leftButton = <NavBackButton to={generateUrl('..')} />;

    return (
        <PageLayout>
            <SidebarHeader heading={t('pageAnalytics.analytics')} leftButton={leftButton} />
            <ScrollableBox style={{ paddingTop: '10px' }}>
                <Feature rule="analytics">
                    <CardStatistics statistics={statistics} getCardStatistics={getCardStatistics} />
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
